import * as styles from "./FeedbackPopUp.module.css";
import { IoMdClose } from "react-icons/io";
import { useState } from "react";
import { PiSmileyMeh, PiSmiley, PiSmileySad } from "react-icons/pi";
import { IoMdSend } from "react-icons/io";


export default function FeedbackPopUp({ onClose, onGeneralFeedbackSubmit, onTextFeedbackSubmit }) {
const [showSendButton, setShowSendButton] = useState(false);
const [rating, setRating] = useState(0);
const [feedbackText, setFeedbackText] = useState('');
const [showThankYou, setShowThankYou] = useState(false);

  const handleRatingChange = (value) => {
    setRating(value);
    onGeneralFeedbackSubmit(value);
    if (value === 3) {
      setShowThankYou(true);
      setTimeout(() => {
        onClose();
      }, 1500);
    }
  };

  const handleTextFeedbackSubmit = () => {
    if (feedbackText.trim()) {
      onTextFeedbackSubmit(feedbackText);
      setFeedbackText('');
      setShowThankYou(true);
      setTimeout(() => {
        onClose();
      }, 1500);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();  // Prevent new line
      handleTextFeedbackSubmit();
    }
  };
    
  return (
    <div className={styles.feedbackPopUp}>
      {!showThankYou && (
        <div className={styles.feedbackHeader}>
          <IoMdClose onClick={onClose} className={styles.closeIcon}/>
        </div>
      )}
      <div className={styles.feedbackContent}>
        {showThankYou ? (
          <div className={styles.feedbackThankYou}>Takk for din tilbakemelding 😊</div>
        ) : (
          <>
            {rating === 0 ? (
              <h4>Hva synes du om denne assistenten?</h4>
            ) : (
              <h4>Hva kan vi forbedre?</h4>
            )}
            {rating === 0 && (
              <div className={styles.rating}>
                <button onClick={() => handleRatingChange(1)} className={styles.ratingButton}><PiSmileySad color="#ff0000" /></button>
              <button onClick={() => handleRatingChange(2)} className={styles.ratingButton}><PiSmileyMeh color="#f3d518" /></button>
                <button onClick={() => handleRatingChange(3)} className={styles.ratingButton}><PiSmiley color="#07d100" /></button>
              </div>
            )}
            {(rating === 1 || rating === 2) && (
              <div className={styles.textFeedback}>
                <textarea
                  value={feedbackText}
                  onChange={(e) => setFeedbackText(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Fortell oss hva vi kan forbedre..."
                  rows={2}
                />
                <button 
                  className={styles.feedbackSendButton}
                  onClick={handleTextFeedbackSubmit}
                >
                  <IoMdSend className={styles.feedbackSendIcon}/>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
